// 设置展开栏头部

import React, { useCallback, useEffect, useMemo, useState, useContext } from "react";
import "./index.less";
import IconFont from "@/components/icon";
import { Employee, Session } from "@/types/chat";
import { Button, Dropdown, Input, message, Modal, Tooltip, Typography, Divider} from "antd";
import { useTranslation } from "react-i18next";
import ImService from "@/server/ImService";
import HeadPortrait from "@/baseComponents/Chat/HeadPortrait";
import { HeadShowType } from "@/types/chat/enum";
import { openUserCardModal, userEscapeString } from "@/utils/chat/index";
import Context from "@/components/chat/context";
import ChatState from "@/types/chat/State";
import { UserState } from "@/models/user";
import { connect } from "dva";
import { checkCanModifyGroup, isGroupAdmin, isGroupOwner } from "@/utils/chat/group";
// eslint-disable-next-line no-duplicate-imports
import bus from "@/utils/bus";
import CopyClipboard from "copy-to-clipboard";
import { isFocusEnv } from "@/utils";
import { analysisLog } from "@/utils/logAnalytics";
import colors from "@/components/styles/colors";
import { GroupExternalTagBySession } from "@/components/Tags";
import { tagsNode } from "@/components/AddressBook/common";
import GroupAvatarEditModal from "./GroupAvatarEditModal";
import { createUploadTask } from "@/server/FileService";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { GroupAttribute } from "@jd/jdee.im.sdk/lib/es/model/Group";

const { Paragraph } = Typography;
const { TextArea } = Input;

interface Props {
  selectedSession: Session;
  teamConfig: any;
  updateCurrentEmployee: Function;
}

function GroupHead(props: Props) {
  const { selectedSession, teamConfig, updateCurrentEmployee } = props;
  const { groupRosterIdentity } = React.useContext(Context);
  const [value, setValue] = useState("");
  const [intro, setIntro] = useState("");
  const [visible, setVisible] = useState(false);
  const [saving, setSaving] = useState(false);
  const [visibleView, setVisibleView] = useState(false);
  const [contextMenuVisible, setContextMenuVisible] = useState(false);
  // 群头像编辑弹窗状态
  const [avatarEditVisible, setAvatarEditVisible] = useState(false);
  const [avatarSaving, setAvatarSaving] = useState(false);
  const { t } = useTranslation("chat");
  useEffect(() => {
    setValue("");
    setIntro("");
  }, [selectedSession.sessionId]);

  const { authInfo: authData, service, appRuntimeEnv, focusSDK } = useContext<GlobalContextConfig>(
    GlobalContext
  );

  const canModifyGroup = useMemo(() => {
    return checkCanModifyGroup({ selectedSession, groupRosterIdentity });
  }, [selectedSession, groupRosterIdentity]);

  // 点击编辑ICON
  const showModal = useCallback(() => {
    if (groupRosterIdentity === "ordinary") {
      setVisible(false);
    } else if (!value) {
      setValue(selectedSession.info?.name);
      setVisible(!visible);
    }
    // if (isGroupOwner(groupRosterIdentity) || isGroupAdmin(groupRosterIdentity)) {
    //     if (selectedSession.info?.intro) {
    //         setIntro(selectedSession.info?.intro);
    //     } else if (!intro) {
    //         setIntro('');
    //     }
    // }
  }, [selectedSession.info, value, groupRosterIdentity, visible]);

  // input 点击确定修改名称
  const confirmEdit = useCallback(async () => {
    if (saving || !visible) {
      return;
    }
    setSaving(true);
    if (value !== "" && value.length <= 50) {
      const instance = ImService.getInstance();
      const result = await instance.setGroupName(selectedSession.id, value);
      // const resultIntro = await instance.setGroupIntro(selectedSession.id, intro);
      if (result) {
        setVisible(false);
        setValue("");
        setSaving(false);
        // setIntro('');
        // 触发一个事件 告知群组是否需要更新日程详情显示数据
        bus.emit("chat:group:refreshScheduleInfo");
      } else {
        message.info(t("failed"));
        setSaving(false);
      }
    } else {
      message.info(t("please-fill-group-name"));
      setSaving(false);
    }
  }, [selectedSession.id, t, value, visible, saving]); // eslint-disable-line

  // input 点击确定修改组介绍
  const confirmEditIntro = useCallback(async () => {
    if (saving || !visibleView) {
      return;
    }
    setSaving(true);
    const instance = ImService.getInstance();
    const resultIntro = await instance.setGroupIntro(selectedSession.id, intro);
    if (resultIntro) {
      setVisibleView(false);
      setIntro("");
      setSaving(false);
      // 触发一个事件 告知群组是否需要更新日程详情显示数据
      bus.emit("chat:group:refreshScheduleInfo");
    } else {
      message.info(t("failed"));
      setSaving(false);
    }
  }, [selectedSession.id, t, intro, visibleView, saving]); // eslint-disable-line

  // 修改input框的value
  const onChange = (e: any) => {
    setValue(e?.target.value);
  };
  const onChangeIntro = (e: any) => {
    setIntro(e?.target.value || "");
  };

  // 点击取消弹框消失
  const handleCancel = useCallback((e: any) => {
    setVisible(false);
    setValue("");
    // setIntro('');
  }, []);

  const handleCancelView = useCallback(() => {
    setVisibleView(false);
    setIntro("");
  }, []);
  const onClickGroupIntro = useCallback(() => {
    if (!selectedSession.info?.intro && groupRosterIdentity === "ordinary") {
      return;
    }
    setIntro(!selectedSession.info?.intro ? "" : selectedSession.info?.intro);
    setVisibleView(true);
  }, [selectedSession.info, groupRosterIdentity]);

  const onVisibleChange = (flag: boolean) => {
    setContextMenuVisible(flag);
  };
  const doCopy = (e: any) => {
    e.stopPropagation();
    if (intro) {
      let userSelection;
      let str = intro;
      if (typeof window.getSelection === "function") {
        userSelection = window.getSelection();
      }
      if (userSelection?.toString()) {
        str = userSelection.toString();
      }
      if ((str || "").length > (intro || "").length) {
        str = intro;
      }
      if (str && CopyClipboard(str)) {
        message.success("复制成功");
      } else {
        message.error("复制失败");
      }
      setContextMenuVisible(false);
    }
  };

  const doPaste = (e: any) => {
    e.stopPropagation();
    focus();
    document.execCommand("paste");
    setContextMenuVisible(false);
  };

  const changeAvatar = useCallback(
    (avatarBlob: Blob, text: string, color: string) => {
      let file: File;
      const fileType = avatarBlob.type || 'image/png'; // 默认为png，可根据实际生成类型调整
      const fileName = `groupAvatar-${Date.now()}.${fileType.split('/')[1]}`; // 自定义文件名（带时间戳避免重复）
      file = new File([avatarBlob], fileName, { type: fileType });
      const task = createUploadTask("id", file, {
        needAuthn: 0, // 是否需要下载健全，可选参数默认需要 上传头像和移动端保持一致，不健全，传0
        fileName: file.name, // 文件名称
        fileType: file.type || "application/octet-stream", // 文件类型
        fileSize: file.size, // 文件大小
        appKey: appRuntimeEnv.fileService.avatarAppKey
      });
      task?.on("state", async (state1: any) => {
        if (state1.state === "completed") {
          if (!state1.downloadUrl) return;
          let avatar = state1.downloadUrl;
          const instance = ImService.getInstance();
          const result = await instance.setGroupAvatar(selectedSession.id, avatar, text, color);
          console.log("上传的头像链接===", avatar, result);
          if (result) {
            // 触发一个事件 告知群组是否需要更新日程详情显示数据
            message.success('群头像修改成功');
            bus.emit("chat:group:refreshScheduleInfo");
          } else {
            message.error('群头像修改失败');
          }
        } else if (state1.state === "failed") {
          message.error(state1?.reason?.message || "头像上传失败，请重试！");
        }
      });
      task?.start();
      if (task!.file.size > 4 * 1024 * 1024) {
        task?.cancel();
        message.error("请上传4MB以内的JPG、JPEG、PNG、BMP、GIF格式的图片");
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [authData]
  );
  

  // 群头像编辑相关函数
  const handleAvatarEditSave = useCallback(async (avatarData: { text: string; color: string; imageBlob?: Blob; defaultAvatar?: string }) => {
    setAvatarSaving(true);
    try {
      if(avatarData.imageBlob){
        // 使用自定义头像
        await changeAvatar(avatarData.imageBlob, avatarData.text, avatarData.color);
      }else if(avatarData.defaultAvatar && avatarData.defaultAvatar !== selectedSession?.info?.avatar){
        // 使用兜底头像
        const instance = ImService.getInstance();
        const result = await instance.setGroupAvatar(selectedSession.id, avatarData.defaultAvatar, avatarData.text, avatarData.color);
        if (result) {
          message.success('群头像修改成功');
          bus.emit("chat:group:refreshScheduleInfo");
        } else {
          message.error('群头像修改失败');
        }
      }
      setAvatarEditVisible(false);
    } catch (error) {
      message.error('群头像修改失败');
    } finally {
      setAvatarSaving(false);
    }
  }, [selectedSession]);

  const handleAvatarEditCancel = useCallback(() => {
    setAvatarEditVisible(false);
  }, []);

  const handleAvatarClick = useCallback(() => {
    // 检查是否为群组且有修改权限
    if (selectedSession.isGroup && (isGroupAdmin(groupRosterIdentity) || isGroupOwner(groupRosterIdentity))) {
      setAvatarEditVisible(true);
      analysisLog("Xtbg_Msg_Setting", "GroupAvatarEdit");
    }
  }, [selectedSession.isGroup, groupRosterIdentity]);

  const modifyGroupPart = useMemo(() => {
    if (!canModifyGroup) {
      return null;
    }
    if (groupRosterIdentity === "ordinary") {
      return null;
    }
    return (
      <Tooltip placement="bottomRight" title={t("edit-group-info")}>
        <div className="group-head-edit-group-name">
          <IconFont
          type="iconbianji1"
          onClick={() => {
            showModal();
          }}
          clstag="pageclick|keycount|Xtbg_Msg_Setting|EditGroupName"
        />
        </div>
        
      </Tooltip>
    );
  }, [canModifyGroup, groupRosterIdentity, showModal, t]);

  const headPortrait = useMemo(() => {
    // 检查是否为群组且有修改权限
    const canEditAvatar = selectedSession.isGroup && (isGroupAdmin(groupRosterIdentity) || isGroupOwner(groupRosterIdentity));
    
    return (
      <div className={`avatar-hover-container avatar-mask ${canEditAvatar ? 'editable' : ''}`}>
        <HeadPortrait
          member={selectedSession}
          width="36px"
          height="36px"
          fontSize="13px"
          imgUrl={selectedSession?.info?.avatar}
          name={selectedSession?.info?.name}
          type={selectedSession?.sessionType}
          isUnFollow={true}
          avatarMask={true}
          showType={HeadShowType.GROUP_SETTING}
          onItemClick={() => {
            // 点击广播号头像不弹出名片
            if (selectedSession.isSingle && !selectedSession.isNotice && !selectedSession.isOrgBroadcast) {
              analysisLog("Xtbg_Msg_Setting", "SessionAvatar");
              openUserCardModal(selectedSession.info as Employee);
            }
            // 如果是群组且有修改群头像权限，打开头像编辑弹窗
            if(selectedSession.isGroup){
              handleAvatarClick();
            }
          }}
        />
        {canEditAvatar && (
          <div className="camera-icon-overlay">
            <IconFont type='iconvector2'/>
          </div>
        )}
      </div>
    );
  }, [selectedSession, groupRosterIdentity, handleAvatarClick]);

  // 底部button
  const modalFooter = (
    <div>
      <Button
        style={{
          border: "1px solid #dee0e3",
          borderRadius: " 4px",
          color: `${colors.black2}`
        }}
        onClick={handleCancel}
        className="cancelBtn"
      >
        {t("cancelText")}
      </Button>
      <Button
        loading={saving}
        type="primary"
        style={{
          border: "none",
          background: "@primary-color",
          borderRadius: "4px",
          fontSize: "14px",
          color: "#ffffff"
        }}
        onClick={confirmEdit}
      >
        {t("determine")}
      </Button>
    </div>
  );

  const modalFooterView = (
    <div>
      <Button
        style={{
          border: "1px solid #dee0e3",
          borderRadius: " 4px",
          color: `${colors.black2}`
        }}
        onClick={handleCancelView}
        className="cancelBtn"
      >
        {t("cancelText")}
      </Button>
      {groupRosterIdentity === "ordinary" ? null : (
        <Button
          loading={saving}
          type="primary"
          style={{
            border: "none",
            background: "@primary-color",
            borderRadius: "4px",
            fontSize: "14px",
            color: "#ffffff"
          }}
          onClick={confirmEditIntro}
        >
          {t("determine")}
        </Button>
      )}
    </div>
  );
  const remark = useMemo(() => {
    const employeeExt = (selectedSession.info as any)?.employeeExt || {};
    const remark = employeeExt?.remark;
    return remark;
  }, [selectedSession]);

  const name = useMemo(() => {
    return `${selectedSession?.info?.name}${remark ? `（${remark}）` : ""}`;
  }, [selectedSession, remark]);
  // console.log(
  //     'group-name=>',
  //     value + 'value',
  //     selectedSession?.info?.name + 'info.name',
  //     userEscapeString(value || selectedSession?.info?.name)
  // );
  return (
    <div className="group-head">
      <div className="group-top">
        {headPortrait}
        <div className="group_name">
          {/* <Tooltip placement="bottom" title={<span dangerouslySetInnerHTML={{ __html: userEscapeString(name) }} />}>
            <span
              className="name-1"
              onClick={() => {
                console.log("selectedSession:", selectedSession);
                if (isOrgChatSession(selectedSession)) {
                  openOrgAcctModal(selectedSession.uid?.pin || "");
                  return;
                }
                if (selectedSession.isSingle && !selectedSession.isNotice) {
                  const user: any = selectedSession.uid
                    ? selectedSession.info
                    : selectedSession.uid;
                  openUserCardModal({
                    userId: user.userId || user.pin,
                    teamId: user.teamId,
                    app: user.app
                  } as any);
                } else {
                  setting(DrawTypeEnum.setup);
                }
              }}
              clstag="pageclick|keycount|Xtbg_Msg|SessionName"
              dangerouslySetInnerHTML={{
                __html: userEscapeString(name)
              }}
            />
          </Tooltip> */}


          <Tooltip placement="bottom" title={<span dangerouslySetInnerHTML={{ __html: userEscapeString(value || name) }} />}>
            <Paragraph ellipsis={{ rows: 2, expandable: true, symbol: " " }}>
              <span dangerouslySetInnerHTML={{
                __html: userEscapeString(value || name)
              }} />
              {/* {userEscapeString(value || name)} */}
              {selectedSession.isSingle && tagsNode(selectedSession?.info?.labelInfoList)}
              <GroupExternalTagBySession session={selectedSession} />
            </Paragraph>
          </Tooltip>
          {modifyGroupPart}
        </div>
        {/* 新增分享按钮-待完成 */}
      </div>
      {/* 不再隐藏组介绍 */}
      {selectedSession.isGroup && (
        <div
          className="group-set"
          onClick={onClickGroupIntro}
          clstag="pageclick|keycount|Xtbg_Msg_Setting|EditGroupIntro"
        >
          <div className="group-set-left">
            <p>{t("group-intro")}</p>
          </div>
          <div
            className="group-gid"
            style={{
              cursor: groupRosterIdentity === "ordinary" ? "default" : "pointer"
            }}
          >
            <div className="group-intro-text">
              {!selectedSession?.info?.intro ? "该群还未添加群介绍" : selectedSession?.info?.intro}
            </div>
          </div>
          {!selectedSession?.info?.intro && groupRosterIdentity === "ordinary" ? null : (
            <div className="group-arrow">
              <IconFont
                type="iconFrame6"
                className="group-management-icon-arrow"
                style={{
                  fontSize: "14px",
                  cursor: groupRosterIdentity === "ordinary" ? "default" : "pointer"
                }}
              />
            </div>
          )}
        </div>
      )}
      <Divider style={{margin: "0 auto", color: "#DBDBDC99", width: "90%", minWidth: "90%"}} />
      <Modal
        centered={true}
        title={<span style={{ fontWeight: "bold" }}>群名称</span>}
        visible={visible}
        onCancel={handleCancel}
        footer={modalFooter}
        wrapClassName="group-intro-modal"
      >
        <div>
          <Input
            placeholder={t("please-enter-group-name")}
            value={value.trim()}
            maxLength={50}
            onChange={onChange}
            style={{ border: " 1px solid @primary-color", borderRadius: "4px" }}
          />
        </div>
      </Modal>
      <Modal
        centered={true}
        title={<span style={{ fontWeight: "bold" }}>群介绍</span>}
        visible={visibleView}
        onCancel={handleCancelView}
        footer={modalFooterView}
        wrapClassName="group-intro-modal"
      >
        {isGroupOwner(groupRosterIdentity) || isGroupAdmin(groupRosterIdentity) ? (
          <div>
            {isFocusEnv() ? (
              <Dropdown
                overlay={() => {
                  return (
                    <div className="contextMenu-wrapper">
                      <div
                        className="contextMenu-item"
                        onClick={(e) => {
                          doPaste(e);
                        }}
                      >
                        粘贴
                      </div>
                      <div className="contextMenu-item" onClick={doCopy}>
                        复制
                      </div>
                    </div>
                  );
                }}
                trigger={["contextMenu"]}
                visible={contextMenuVisible}
                onVisibleChange={onVisibleChange}
              >
                <TextArea
                  rows={6}
                  placeholder={t("please-enter-group-intro")}
                  value={intro}
                  maxLength={500}
                  onChange={onChangeIntro}
                  style={{
                    border: " 1px solid @primary-color",
                    borderRadius: "4px",
                    resize: "none"
                  }}
                />
              </Dropdown>
            ) : (
              <TextArea
                rows={6}
                placeholder={t("please-enter-group-intro")}
                value={intro}
                maxLength={500}
                onChange={onChangeIntro}
                style={{
                  border: " 1px solid @primary-color",
                  borderRadius: "4px",
                  resize: "none"
                }}
              />
            )}
          </div>
        ) : (
          <Dropdown
            overlay={() => {
              return (
                <div className="contextMenu-wrapper">
                  <div className="contextMenu-item" onClick={doCopy}>
                    复制
                  </div>
                </div>
              );
            }}
            trigger={["contextMenu"]}
            visible={contextMenuVisible}
            onVisibleChange={onVisibleChange}
          >
            <div className="group-intro-content">
              {selectedSession.isGroup &&
                !!selectedSession?.info?.intro &&
                selectedSession.info.intro}
            </div>
          </Dropdown>
        )}
      </Modal>

      {/* 群头像编辑弹窗 */}
      {avatarEditVisible && <GroupAvatarEditModal
        teamConfig={teamConfig}
        visible={true}
        onCancel={handleAvatarEditCancel}
        onSave={handleAvatarEditSave}
        currentText={(selectedSession?.info as GroupAttribute).headImageText || ""}
        currentColor={(selectedSession?.info as GroupAttribute).headImageColor || ""}
        loading={avatarSaving}
        avatar={selectedSession?.info?.avatar || ""}
      />}
      
    </div>
  );
}

function mapStateToProps({ chat, user }: any) {
  const { selectedSession } = chat as ChatState;
  const { teamConfig } = user as UserState;
  return { selectedSession, teamConfig };
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateCurrentEmployee(payload: any) {
      dispatch({ type: "chat/updateCurrentEmployee", payload });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupHead);
function data(data: any) {
  throw new Error("Function not implemented.");
}
